<template>
  <div class="login text-center">
    <ValidationObserver
        ref="observer"
        v-slot="{ invalid }"
    >
      <form @submit.prevent="onSubmit">
        <img class="mb-4" src="@/assets/images/4linux.png" alt="4Linux logo" width="72" height="72">
        <h2>Utilize o mesmo acesso do Moodle para entrar</h2>

        <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
          <v-text-field
              label="E-mail"
              type="email"
              v-model="email"
              :error-messages="errors"
              filled
              required
          />
        </ValidationProvider>
        <ValidationProvider name="password" rules="required" v-slot="{ errors }">
          <v-text-field
              label="Senha"
              type="password"
              v-model="password"
              :error-messages="errors"
              filled
              required
          />
        </ValidationProvider>

        <v-btn
            class="my-3"
            type="submit"
            :disabled="invalid"
        >
          Entrar
        </v-btn>
      </form>
    </ValidationObserver>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import AuthService from '@/services/auth/auth.service';
import RouterService from '@/services/router/router.service.ts';

const authService = new AuthService();
const routerService = new RouterService();

export default {
  name: 'Login',
  data: () => ({
    email: '',
    password: '',
    snackbar: false,
    snackbarText: '',
  }),
  methods: {
    onSubmit() {
      this.$refs.observer.validate();

      authService
          .authenticate(this.email, this.password)
          .then((response) => {
            authService.updateToken(response.data.accessToken);

            this.$router.push(routerService.getHomeRoute());
          })
          .catch(() => {
            this.snackbar = true;
            this.snackbarText = 'Usuário ou senha inválidos';
          });
    }
  },
};
</script>

<style scoped>
.login {
  display: flex;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 40px;
  flex-direction: column;
  align-content: space-around;
  justify-content: center;
}

.login h2 {
  font-weight: normal;
}
</style>
